import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { getBuildingFormSchema } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { z } from "zod";

export const getCottageFormSchema = (t: TranslateFunction) =>
	getBuildingFormSchema(t, ClientPropertyTypeEnum.Cottage);

export type CottageFormInput = z.input<ReturnType<typeof getCottageFormSchema>>;
export type CottageFormOutput = z.output<
	ReturnType<typeof getCottageFormSchema>
>;
